





































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencyKBModule } from '@/store/modules/agencyKB';
import Alert from '@/components/Shared/Alert.vue';
import MarkdownRenderer from '@/components/KnowledgeBase/MarkdownRenderer.vue';
import ArticleTableOfContents from '@/components/KnowledgeBase/ArticleTableOfContents.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import KBContentDto from '@/models/KnowledgeBase/KBContentDto';
import KBPublishedContent from '@/models/KnowledgeBase/KBPublishedContent';
import KBContentListItem from '@/models/KnowledgeBase/KBContentListItem';
import KBStatus from '@/models/KnowledgeBase/KBStatus';

@Component({
  name: 'AgencyKBArticle',
  components: {
    Alert,
    MarkdownRenderer,
    ArticleTableOfContents
  }
})
export default class extends GiganautVue {
  private initializing = true;

  get loading(): boolean {
    return AgencyKBModule.loadingContent || this.initializing;
  }

  get content(): KBContentDto | null {
    return AgencyKBModule.currentContent;
  }

  get article(): KBPublishedContent | null {
    return this.content?.published || null;
  }

  get contentList(): KBContentListItem[] | undefined {
    return AgencyKBModule.contentList?.items;
  }

  get relatedArticles(): KBContentListItem[] {
    if (!this.content) return [];

    // Get articles from the same parent (siblings)
    return (AgencyKBModule.contentList?.items || [])
      .filter(item =>
        item.parentId === this.content?.parentId &&
        item.id !== this.content?.id &&
        item.status === KBStatus.Published
      )
      .slice(0, 5);
  }

  @Watch('$route')
  onRouteChange() {
    this.initializing = true;
    this.loadArticle();
  }

  created() {
    this.loadArticle();
    // Load content list for related articles
    AgencyKBModule.getContentList({ status: KBStatus.Published });
  }

  async loadArticle() {
    const slug = this.$route.params.slug;

    // First, we need to find the content by slug
    // Since we don't have a direct slug lookup, we'll use the content list
    await AgencyKBModule.getContentList({ status: KBStatus.Published });

    const item = AgencyKBModule.contentList?.items.find(
      c => c.slug === slug
    );

    if (item) {
      await AgencyKBModule.getContent(item.id);
    }

    // Only hide initializing state after article is loaded
    this.initializing = false;
  }
}
